import { configure, makeAutoObservable, runInAction } from 'mobx';

import { AgentContractAgreementsStore } from '@features/agent-contract-agreements';

import { AgentActsStore } from '@entities/agent-act';
import { AgentContractStore } from '@entities/agent-contract';
import { AgentUserStore } from '@entities/agent-user';
import { CandidateContractStore } from '@entities/candidate-contract';
import { DictionariesStore } from '@entities/dictionaries';
import { ProductsStore } from '@entities/main-products';
import { OtpCooldownStore } from '@entities/otp';

configure({
  enforceActions: 'always',
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: false,
  disableErrorBoundaries: true,
});

class Main {
  public agentUserStore: AgentUserStore;
  public agentContractStore: AgentContractStore;
  public candidateContractStore: CandidateContractStore;
  public dictionariesStore: DictionariesStore;
  public agentContractAgreementsStore: AgentContractAgreementsStore;
  public agentActsStore: AgentActsStore;
  public productsStore: ProductsStore;
  public otpCooldownStore: OtpCooldownStore;

  constructor() {
    this.agentUserStore = new AgentUserStore(this);
    this.agentContractStore = new AgentContractStore(this);
    this.candidateContractStore = new CandidateContractStore(this);
    this.dictionariesStore = new DictionariesStore(this);
    this.agentContractAgreementsStore = new AgentContractAgreementsStore(this);
    this.agentActsStore = new AgentActsStore(this);
    this.productsStore = new ProductsStore(this);
    this.otpCooldownStore = new OtpCooldownStore(this);
    makeAutoObservable(this);
  }

  resetStore() {
    runInAction(() => {
      this.agentUserStore.reset();
      this.agentContractStore.reset();
      this.dictionariesStore.reset();
      this.agentContractAgreementsStore.reset();
      this.agentActsStore.reset();
      this.productsStore.reset();
      this.candidateContractStore.reset();
    });
  }
}

export { Main };
